import { Link } from "react-router-dom";
import { endingCover } from "../../../mocks/site";

export default function EndingBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 pb-4 md:pb-6">
      <div className="relative overflow-hidden rounded-3xl">
        <img
          src={endingCover}
          alt="守护甜心结局剧情详解横幅"
          className="h-72 w-full object-cover object-top md:h-80"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 via-primary-900/50 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-12 lg:max-w-lg">
          <span className="inline-flex w-fit rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
            结局剧情详解
          </span>
          <h2 className="mt-4 font-display text-2xl text-background-50 md:text-4xl">
            一次看懂守护甜心的结局
          </h2>
          <p className="mt-3 text-sm leading-6 text-background-50/85 md:text-base">
            每位角色的最终归宿、主线矛盾的收束、开放结局背后的温柔——都在这里为你逐层拆解。
          </p>
          <Link
            to="/ending"
            className="mt-6 inline-flex w-fit items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 whitespace-nowrap hover:bg-accent-300"
          >
            查看结局详解
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}